import { P2GStack, P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { nextCollectionDate } from '~/lib/quotes';
import { DateElement } from '~/lib/types/basket-types';
import dayjs from 'dayjs';
import { toLocaleDateString } from '~/lib/dates';

function QuoteCardServiceTypeCollection({ dates }: { dates: DateElement[] }) {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);

  const nextDate: DateElement | undefined = useMemo(() => {
    return nextCollectionDate(dates);
  }, [dates]);

  if (!nextDate || !nextDate.collection) {
    return null;
  }

  const now = dayjs();
  const collectionDate = dayjs(nextDate.collection.date);
  const cutOff = dayjs(nextDate.cutoff);
  const collectionToday = collectionDate.isSame(now, 'day');
  const collectionTomorrow = !collectionToday && collectionDate.isSame(now.add(1, 'day'), 'day');
  const diffHours = cutOff.diff(now, 'hours');
  const diffMinutes = cutOff.diff(now, 'minutes');

  return (
    <P2GStack>
      <P2GText
        className="text-secondary"
        sx={{
          '&.MuiTypography-root': {
            fontSize: '14px',
            fontWeight: 'bold'
          }
        }}
      >
        {collectionToday &&
          t('QUOTE_COLLECTION_DATE_TODAY', {
            defaultValue: 'Collection Today'
          })}
        {collectionTomorrow &&
          t('QUOTE_COLLECTION_DATE_TOMORROW', {
            defaultValue: 'Collection Tomorrow'
          })}
        {!collectionToday && !collectionTomorrow && t('COLLECTION', { defaultValue: 'Collection' })}
      </P2GText>
      <P2GText
        sx={{
          '&.MuiTypography-root': {
            fontSize: '12px'
          }
        }}
      >
        {(collectionToday || collectionTomorrow) &&
          t('QUOTE_COLLECTION_CUT_OFF', {
            defaultValue: 'if booked within {{value}} {{units}}',
            value: diffHours > 0 ? diffHours : diffMinutes,
            units: diffHours > 0 ? 'hours' : 'minutes'
          })}
        {!collectionToday && !collectionTomorrow && <span>{toLocaleDateString(nextDate.collection.date)}</span>}
      </P2GText>
    </P2GStack>
  );
}

export default QuoteCardServiceTypeCollection;
